const maintenance = {
  clientPortalMainMessage: 'Sorry, the client portal is currently closed for maintenance',
  clientPortalSecondaryMessage: 'Please try again later',
  workerPortalMainMessage: 'Sorry, the worker portal is currently closed for maintenance',
  workerPortalSecondaryMessage: 'Please try again later',
  refresh: 'Refresh',
};

export default maintenance;
